import { render, staticRenderFns } from "./HomeSection.vue?vue&type=template&id=4808d67a&scoped=true&"
import script from "./HomeSection.vue?vue&type=script&lang=ts&"
export * from "./HomeSection.vue?vue&type=script&lang=ts&"
import style0 from "./HomeSection.vue?vue&type=style&index=0&id=4808d67a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4808d67a",
  null
  
)

export default component.exports